var map = {
	"./attendees.jpg": 472,
	"./booth.jpg": 473,
	"./booth_collage.jpg": 474,
	"./breakout.jpg": 475,
	"./breakout_alt.jpg": 476,
	"./bunting.jpg": 477,
	"./caversham.jpg": 478,
	"./close.jpg": 479,
	"./collide.jpg": 480,
	"./collide_crowd.jpg": 481,
	"./crowd.jpg": 482,
	"./crowd_alt.jpg": 483,
	"./crowd_closeup.jpg": 484,
	"./hoops.jpg": 485,
	"./joel.jpg": 486,
	"./lee.jpg": 487,
	"./lunch.jpg": 488,
	"./organisers.jpg": 489,
	"./outside.jpg": 490,
	"./patima_afterparty.jpg": 491,
	"./photo_booth.jpg": 492,
	"./phuong.jpg": 493,
	"./quokkas.jpg": 494,
	"./rottnest.jpg": 495,
	"./sign.jpg": 496,
	"./stage.jpg": 497,
	"./stage_high.jpg": 498,
	"./swag.jpg": 499,
	"./talks/alice.jpg": 233,
	"./talks/andy.jpg": 234,
	"./talks/espen.jpg": 235,
	"./talks/jina.jpg": 236,
	"./talks/joel.jpg": 237,
	"./talks/mike.jpg": 238,
	"./talks/una.jpg": 239,
	"./team.jpg": 500,
	"./teegan_dt.jpg": 501,
	"./tote.jpg": 502,
	"./una_kylie.jpg": 503,
	"./una_sketch.jpg": 504,
	"./workshop.jpg": 505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 471;